import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Breadcrumbs,
  PageTitleAndSubTitle,
  CardComponent,
  BasicTable,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import utilizationProvider from '../../core-utils/messages/utilizationProvider';
import {
  TopFacilityColumns,
  TopPhysicansColumns,
} from './utilizationProviderConstants';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import properties from '../../core-utils/properties';
import axios from 'axios';
import Loader from '../../_components/molecules/Loader';
import { APIResponseForFacilitiesAndPhysicains } from '../../core-utils/helper-utils/utilizationProviderHelpers';
import { useStores } from '../../stores';
import { COMMON_TEXTS } from '../../core-utils/messages/CommonConstants';
import {
  addPrefix,
  commasForNumbers,
} from '../../core-utils/helper-utils/helper';
import { useNavigate } from 'react-router-dom';
import ReportsModal from '../../_components/organisms/ReportsModal';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import DateFilter from '../../_components/molecules/DateFilter';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import { observer } from 'mobx-react';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import componentConstants from '../../core-utils/messages/componentConstants';
import { DEEP_DIVE } from '../../core-utils/routes';
import { DottedText } from '../../core-utils/helper-utils/financialForensicsHelper';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { getCohortMembersCount } from '../../core-utils/axios/Cohort/Summary';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';

const UtilizationProvider = observer(() => {
  const useStyles = makeStyles()({
    mainDiv: {
      marginTop: '40px',
      marginLeft: '63px',
      width: '1182px',
    },
    flexContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '24px',
      marginBottom: '28px',
    },
    OverViewCardMargin: {
      marginRight: '24px',
    },
  });
  const { classes } = useStyles();
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;

  const {
    employerGroupStore,
    quaterlyReportStore,
    loginPageStore,
    cohortDetailsStore,
    recommendedTabStore,
  } = useStores();
  //State Variables:
  const [topFacilityLoading, setTopFacilityLoading] = useState<boolean>(false);
  const [topPhysiciansLoading, setTopPhysiciansLoading] = useState<boolean>(
    false,
  );

  const [topFacilities, setTopFacilities] = useState<
    APIResponseForFacilitiesAndPhysicains[]
  >();
  const [topPhysicians, setTopPhysicians] = useState<
    APIResponseForFacilitiesAndPhysicains[]
  >();

  const navigate = useNavigate();
  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const screenName = allScreenLabel;
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);

  //Enrollment Cards--
  const [facilitiesPageNumber, setFacilitiesPageNumber] = useState<number>(1);
  const [facilitiesTotalPages, setFacilitiesTotalPages] = useState<number>(0);
  const [physiciansTotalPages, setPhysiciansTotalPages] = useState<number>(0);
  const [physiciansPageNumber, setPhysicainsPageNumber] = useState<number>(1);

  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );

  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quaterlyReportStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const { open, openModal, closeModal, isEditMode } = useCohortModal();

  const { totalResults, isInitializing } = useCohortOnPageLoad({
    fetchTotalResults: () =>
      getCohortMembersCount(
        employerGroupStore.employerGroupResponseData.eg_nid,
        aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
        employerGroupStore.employerGroupResponseData.max_claim_date,
      ),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
  });

  const abortController = new AbortController();

  //snackbar
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        utilizationProvider.titleAndSubtitle.title,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiSummarizedData();
  };

  useEffect(() => {
    if (isInitializing) {
      return;
    }

    if (isPlanDatesFetched) {
      getTopFacilities();
    }
    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    facilitiesPageNumber,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);

  useEffect(() => {
    if (isInitializing) {
      return;
    }

    if (isPlanDatesFetched) {
      getTopPhysicians();
    }
  }, [
    isInitializing,
    physiciansPageNumber,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);

  //API Calls:
  //Top Facilities - In network-
  const getTopFacilities = async () => {
    setTopFacilityLoading(true);
    const baseUrl =
      properties.aiqBaseUrl +
      properties.utilizationRxBaseUrl +
      properties.topFacilities;
    const body = {
      ...payload,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      pageNumber: facilitiesPageNumber - 1,
      sortField: 'totalCharge',
    };
    await axios
      .post(baseUrl, body, { signal: abortController.signal })
      .then((res: any) => {
        if (res) {
          const totalItems = res?.data?.data?.totalCount;
          const totalPages = Math.ceil(totalItems / 10);
          setFacilitiesTotalPages(totalPages);
          setTopFacilities(res.data.data.topFacility);
        }
      })
      .catch(() => {});
    setTopFacilityLoading(false);
  };

  const getTopPhysicians = async () => {
    setTopPhysiciansLoading(true);
    const baseUrl =
      properties.aiqBaseUrl +
      properties.utilizationRxBaseUrl +
      properties.topPhysicians;
    const body = {
      ...payload,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      pageNumber: physiciansPageNumber - 1,
      sortField: 'totalCharge',
    };
    await axios
      .post(baseUrl, body, { signal: abortController.signal })
      .then((res: any) => {
        if (res) {
          const totalItems = res?.data?.data?.totalCount;
          const totalPages = Math.ceil(totalItems / 10);
          setPhysiciansTotalPages(totalPages);
          setTopPhysicians(res.data.data.topPhysicians);
        }
      })
      .catch(() => {});
    setTopPhysiciansLoading(false);
  };

  //Data-Preparation:

  const getDataForTable = (type: string) => {
    const data: any[] = [];
    if (type === 'Physicians') {
      topPhysicians?.forEach((item) => {
        const row = [];
        row.push(
          item.providerName === '' ? (
            '-'
          ) : (
            <DottedText
              text={item.providerName}
              onClick={() => {
                navigate(DEEP_DIVE, {
                  state: {
                    key: 'provider_name',
                    value: item.providerName,
                  },
                });
              }}
            />
          ),
        );
        row.push(item.claims);
        row.push(
          addPrefix('$', commasForNumbers(item.totalCharge?.toString(), 2)),
        );
        row.push(
          addPrefix('$', commasForNumbers(item.planPaid?.toString(), 2)),
        );
        // row.push(item.paidPercent !== null ? `${item.paidPercent}%` : '0.00%');
        data.push(row);
      });
    } else {
      topFacilities?.forEach((item) => {
        const row = [];
        row.push(
          item.providerName === '' ? (
            '-'
          ) : (
            <DottedText
              text={item.providerName}
              onClick={() => {
                navigate(DEEP_DIVE, {
                  state: {
                    key: 'provider_name',
                    value: item.providerName,
                  },
                });
              }}
            />
          ),
        );
        row.push(item.claims);
        row.push(
          addPrefix('$', commasForNumbers(item.totalCharge?.toString(), 2)),
        );
        row.push(
          addPrefix('$', commasForNumbers(item.planPaid?.toString(), 2)),
        );
        // row.push(item.paidPercent !== null ? `${item.paidPercent}%` : '0.00%');
        data.push(row);
      });
    }

    return data;
  };

  const getAllFacilitiesForSummary = async () => {
    try {
      const baseUrl =
        properties.aiqBaseUrl +
        properties.utilizationRxBaseUrl +
        properties.topFacilities;

      const body = {
        ...payload,
        member_unique_id_list: [],
        pageNumber: 0,
        includeAllProviders: true, // backend flag
        sortField: 'totalCharge',
      };

      const res = await axios.post(baseUrl, body);

      return res?.data?.data?.topFacility || [];
    } catch (error) {
      console.error('Facilities summary fetch error', error);
      return [];
    }
  };

  const getAllPhysiciansForSummary = async () => {
    try {
      const baseUrl =
        properties.aiqBaseUrl +
        properties.utilizationRxBaseUrl +
        properties.topPhysicians;

      const body = {
        ...payload,
        member_unique_id_list: [],
        pageNumber: 0,
        includeAllProviders: true,
        sortField: 'totalCharge',
      };

      const res = await axios.post(baseUrl, body);

      return res?.data?.data?.topPhysicians || [];
    } catch (error) {
      console.error('Physicians summary fetch error', error);
      return [];
    }
  };
  const getAiSummarizedData = async () => {
    try {
      setAiLoading(true);

      // fetch full datasets
      const facilities = await getAllFacilitiesForSummary();
      const physicians = await getAllPhysiciansForSummary();

      // take only top 20 (recommended for AI)
      const topFacilities = facilities
        ?.sort((a: any, b: any) => b.totalCharge - a.totalCharge)
        ?.slice(0, 20);

      const topPhysicians = physicians
        ?.sort((a: any, b: any) => b.totalCharge - a.totalCharge)
        ?.slice(0, 20);

      // clean data
      const cleanFacilities = topFacilities?.map((item: any) => ({
        facilityName: item?.facilityName,
        claims: item?.claims,
        totalCharge: item?.totalCharge,
        planPaid: item?.planPaid,
      }));

      const cleanPhysicians = topPhysicians?.map((item: any) => ({
        physicianName: item?.physicianName,
        claims: item?.claims,
        totalCharge: item?.totalCharge,
        planPaid: item?.planPaid,
      }));

      const apiResponses = {
        title_1: cleanFacilities,
        title_2: cleanPhysicians,
      };

      let resultArray = []; // ✅ default fallback

      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getAiSummary,
          {
            screenName: screenName.TOP_PROCEDURES,
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
            incurredStartDate,
            incurredEndDate,
            paidStartDate,
            paidEndDate,
            apiData: apiResponses,
          },
        );

        // ✅ Safe extraction
        resultArray = response?.data?.data?.data?.result || [];
        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      } catch (apiError) {
         
        console.error('AI Summary API failed:', apiError);
        // ✅ Optional: show user-friendly message
        handleOpenSnackBar('Failed to load summary', 'warning', 4000);
        setAiSummaryData([]);
      }
    } catch (error: any) {
      handleOpenSnackBar(error, 'error', 6000);
    } finally {
      setAiLoading(false);
    }
  };

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  const GetPath = () => {
    return (
      <Box style={{ marginBottom: '20px' }}>
        <Breadcrumbs
          itemList={[
            [
              'text',
              'Medical Claim Utilization',
              {
                color: patientAccessTheme.palette.primary[500],
                fontWeight: 500,
              },
              () => {
                navigate(-1);
              },
            ],
            [
              'text',
              utilizationProvider.titleAndSubtitle.title,
              {
                color: patientAccessTheme.palette.text.highemphasis,
                fontWeight: 600,
              },
            ],
          ]}
        />
      </Box>
    );
  };

  const [loader] = useState<any>(<Loader />);

  return isPlanDatesLoading ? (
    loader
  ) : (
    <Box className={classes.mainDiv}>
      <GetPath />
      <Box style={{ width: '1182px', position: 'relative' }}>
        <PageTitleAndSubTitle
          title={
            <Box
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Typography
                fontSize="18px"
                fontType="semiBold"
                textColor={patientAccessTheme.palette.text.highemphasis}
                lineHeight="22px"
                styleProps={{ marginRight: '8px' }}
              >
                {utilizationProvider.titleAndSubtitle.title}
              </Typography>
            </Box>
          }
          subTitle={utilizationProvider.titleAndSubtitle.subtitle}
          showDownloadButton={true}
          // downloadButtonAction={() => setOpenReportsModal(true)}
          downloadButtonAction={() => {
            downloadPdf(
              'utilizationProviderReport',
              {
                employer:
                  employerGroupStore?.employerGroupResponseData
                    ?.employer_group_name,
                member_unique_id_list: [],
                claim_id_list: [],
                maxClaimDate:
                  employerGroupStore?.employerGroupResponseData?.max_claim_date,
                ...payload,
              },
              handleOpenSnackBar,
              'open',
            );
            handleOpenSnackBar(
              snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
              'info',
              6000,
            );
          }}
          showAskAi={true}
          askAiAction={handleAskAi}
          showQueryDataButton={checkUserAccess(
            UserAccessConstants.COHORT_DETAILS,
            loginPageStore.userResponse.role.name,
            loginPageStore.userFeatures,
          )}
          queryButtonText={
            cohortDetailsStore.cohortDetailsList?.length > 0 &&
            cohortDetailsStore.cohortDetailsList[0].category !== ''
              ? 'Edit Cohort'
              : 'Add Cohort'
          }
          queryDataAction={() => {
            if (
              checkUserAccess(
                UserAccessConstants.COHORT_DETAILS,
                loginPageStore.userResponse.role.name,
                loginPageStore.userFeatures,
              )
            ) {
              openModal();
            }
          }}
        />
        {/* edit duration */}
        <div
          style={{
            position: 'absolute',
            top: '-1px',
            left: '168px',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <Typography
            fontSize="17px"
            lineHeight="21px"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            fontType="semiBold"
            margin="0px 8px"
          >
            {COMMON_TEXTS.FOR}
          </Typography>
          <DateFilter />
        </div>
        <TabSelection
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={handleSelectedIndex}
          recommendationFetched={recommendationFetched}
        />
      </Box>
      {selectedTabIndex === 0 && (
        <>
          {/* Facilities Table */}
          <CohortFilterBar />
          <CardComponent
            title={utilizationProvider.TableTextForTopFacilities.title}
            subTitle={utilizationProvider.TableTextForTopFacilities.subtitle}
            body={
              topFacilityLoading ? (
                <Box
                  style={{
                    display: 'flex',
                    height: '450px',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <CircularLoader />
                </Box>
              ) : (
                <BasicTable
                  displayType="row"
                  columns={TopFacilityColumns}
                  rowsData={getDataForTable('Facilities')}
                  pageNumber={facilitiesPageNumber}
                  pageCount={facilitiesTotalPages}
                  showPagination={true}
                  handlePagination={(
                    event: ChangeEvent<unknown>,
                    page: number,
                  ) => setFacilitiesPageNumber(page)}
                  width="100%"
                  headerCellHeight="48px"
                  cellPadding="8px 16px 8px 20px"
                  showOnHoverHeader={true}
                  isFullTable
                />
              )
            }
            mainGridStyles={{
              margin: '1rem 0',
            }}
          />
          {/* Physicians Table */}
          <CardComponent
            title={utilizationProvider.TableTextForTopPhysicans.title}
            subTitle={utilizationProvider.TableTextForTopPhysicans.subtitle}
            body={
              topPhysiciansLoading ? (
                <Box
                  style={{
                    display: 'flex',
                    height: '450px',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <CircularLoader />
                </Box>
              ) : (
                <BasicTable
                  displayType="row"
                  columns={TopPhysicansColumns}
                  rowsData={getDataForTable('Physicians')}
                  pageNumber={physiciansPageNumber}
                  pageCount={physiciansTotalPages}
                  showPagination={true}
                  handlePagination={(
                    event: ChangeEvent<unknown>,
                    page: number,
                  ) => setPhysicainsPageNumber(page)}
                  width="100%"
                  headerCellHeight="48px"
                  cellPadding="8px 16px 8px 20px"
                  showOnHoverHeader={true}
                  isFullTable
                />
              )
            }
            mainGridStyles={{
              marginBottom: '1rem',
            }}
          />
        </>
      )}
      {selectedTabIndex === 1 && (
        <RecommendationsTab
          recommendationLoading={recommendationLoading}
          isInternalPage={true}
        />
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData}
        loading={aiLoading}
      />
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={
          aggregationParameter === 'paid' ? paidStartDate : incurredStartDate
        }
        endDate={
          aggregationParameter === 'paid' ? paidEndDate : incurredEndDate
        }
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
      />
    </Box>
  );
});

export default UtilizationProvider;
